import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <>
        <div className="text-xl font-medium">Oops! IDP</div>
        <div>
          {error.status} {error.statusText}
        </div>
      </>
    );
  }

  return <div className="text-xl font-medium">Unknown Error!</div>;
}
